import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useUserContext } from '../common';

import { signout } from '.';
import { Button, useMediaQuery } from '@mui/material';

export function AuthButton() {
  const matchesTabsBreakpoint = useMediaQuery('(min-width:40em)', {
    noSsr: true,
  });

  const {
    user: { isAuthenticated },
    setUser,
  } = useUserContext();

  return isAuthenticated ? (
    <Button
      variant="outlined"
      color="secondary"
      aria-label={matchesTabsBreakpoint ? void 0 : 'Log Out'}
      onClick={signout(setUser)}>
      <FontAwesomeIcon icon={faSignOutAlt} size="1x" fixedWidth />

      {matchesTabsBreakpoint && <span>Log Out</span>}
    </Button>
  ) : (
    <p></p>
  );
}
